import { LazyLoadImage } from 'react-lazy-load-image-component';
import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

const Local_FormSectionBgColor = '#FF7A7B';

export const FormSection = styled.section`
    position: relative;
    width: 100%;
    margin-bottom: 80px;
    background-color: ${Local_FormSectionBgColor};
`;

export const FormBlock = styled.div`
    position: relative;
    width: 690px;
    margin: 24px 0;
    z-index: 5;

    @media (max-width: ${wideBreakpoints.laptop}) {
        width: 455px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 100%;
    }
`;

export const FormPatternBlock = styled.div<{ bgImg: string }>`
    position: absolute;
    top: 0;
    left: max(calc(100vw - 950px), 975px);
    bottom: 0;
    width: 950px;
    background-image: url(${p => p.bgImg});
    background-position: right;
    background-size: auto 100%;
    background-repeat: no-repeat;
    z-index: 3;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        left: max(calc(100vw - 620px), 810px);
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        left: max(calc(100vw - 520px), 520px);
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        display: none;
    }
`;

export const FormPattern = styled(LazyLoadImage)`
    width: 100%;
    height: 100%;
    object-position: top;
    object-fit: cover;
`;
